import React from 'react'
import BusinessManagementComp from '../../components/BusinessManagementComponsnts/BusinessMangementComp'

const BusinessManagement = () => {
    return (
        <>
            <BusinessManagementComp />
        </>
    )
}

export default BusinessManagement
